import HeaderSection, { HeaderSectionProps } from 'components/padi-ui/header-section';
import { useFormat } from 'helpers/hooks/useFormat';
import { Product } from 'shared/types/product/Product';

export interface ProductDescriptionConfigProps {
  title?: string;
  htag?: string;
}
export interface ProductDescriptionProps extends Partial<Pick<HeaderSectionProps, 'titleSize'>> {
  product: Record<string, any> | Product;
  productDescriptionConfig?: ProductDescriptionConfigProps;
}

const ProductDescription: React.FC<ProductDescriptionProps> = ({
  product,
  productDescriptionConfig,
  titleSize = 'text-4xl',
}) => {
  const { formatMessage } = useFormat({ name: 'product' });
  const productType = product?.productType;
  let descriptionLabel: string;
  let langaugeAnchorLabel: string;
  let giftingAnchorLabel: string;
  const { title: productDescriptionTitle, htag } = productDescriptionConfig || {};

  switch (productType) {
    case 'Course':
    case 'course':
      descriptionLabel =
        productDescriptionTitle ||
        formatMessage({
          id: 'course.desc.label',
          defaultMessage: 'About the Course',
        });
      langaugeAnchorLabel = formatMessage({
        id: 'course.language.anchor.label',
        defaultMessage: 'Available Languages',
      });
      giftingAnchorLabel = formatMessage({
        id: 'course.gifting.anchor.label',
        defaultMessage: 'How to gift PADI eLearning Courses',
      });
      break;
    case 'bundle-parent':
      descriptionLabel =
        productDescriptionTitle ||
        formatMessage({
          id: 'bundle.desc.label',
          defaultMessage: 'About the Bundle',
        });
      langaugeAnchorLabel = '';
      giftingAnchorLabel = '';
      break;
    case `subscription`:
      descriptionLabel =
        productDescriptionTitle ||
        formatMessage({
          id: 'subscription.club.desc.label',
          defaultMessage: "What's Included",
        });
      langaugeAnchorLabel = '';
      giftingAnchorLabel = '';
      break;
    case `certification-card`:
      descriptionLabel =
        productDescriptionTitle ||
        formatMessage({
          id: 'cert.design.label',
          defaultMessage: 'About the Design',
        });
      langaugeAnchorLabel = '';
      giftingAnchorLabel = '';
      break;
    default:
      descriptionLabel =
        productDescriptionTitle ||
        formatMessage({
          id: 'product.desc',
          defaultMessage: 'About this product',
        });
      langaugeAnchorLabel = '';
      giftingAnchorLabel = '';
  }

  const description = product?.description;

  // let description = product?.description;

  // if (langaugeAnchorLabel) {
  //   description = `${description}<p class="prose"><a class="no-underline" href="#languages">${langaugeAnchorLabel}</a></p>`;
  // }
  // if (giftingAnchorLabel) {
  //   description = `${description}<p class="prose"><a class="no-underline" href="#gifting">${giftingAnchorLabel}</a></p>`;
  // }

  return (
    <HeaderSection
      eyebrow=""
      title={descriptionLabel}
      titleHtag={htag || 'h2'}
      titleSize={titleSize}
      body={description}
      bgColor="white"
      textAlign="left"
    />
  );
};

export default ProductDescription;
